// extracted by mini-css-extract-plugin
export default {"primaryText":"PrimaryText_primaryText__j9LmF"};